import { render, staticRenderFns } from "./CueWordLoading.vue?vue&type=template&id=ed3efdb8&scoped=true&"
import script from "./CueWordLoading.vue?vue&type=script&lang=js&"
export * from "./CueWordLoading.vue?vue&type=script&lang=js&"
import style0 from "./CueWordLoading.vue?vue&type=style&index=0&id=ed3efdb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3efdb8",
  null
  
)

export default component.exports